import React from 'react'
import styles from '@/styles/FieldsetComponent.module.css'

// import ReviewButton from './ReviewButton'
import { useTranslation } from 'react-i18next'

const FieldsetComponent = () => {
  const { t, i18n } = useTranslation()

  return (
    <div className={styles.card}>
      <fieldset className={styles.fieldset}>
        <legend>{t('Extra toppings on pizza')}</legend>
        <ul className={styles.fieldsetList}>
          <li className={styles.legendListWrapper}>
            <div className={styles.legenList}>
              {t('Cheese, Mushrooms, Pineapple, Tomatoes')}
              <br />
              {t('Olives, Eggs, Gorgonzola')}
            </div>
            <span className={styles.span}>15kr</span>
          </li>
          <li>
            {t('Salami, Mussels, Double dough on pizza')}
            <span className={styles.span}>20kr</span>
          </li>
          <li>
            {t('Bacon, minced meat, ham')}
            <span className={styles.span}> 20kr</span>
          </li>
          <li>
            {t('Prawns, Kebab, Parma ham, Beef tenderloin(Oxfilé)')}
            <span className={styles.span}> 40kr</span>
          </li>
          <li>
            {t('Fries on the pizza, chicken')}
            <span className={styles.span}> 40kr</span>
          </li>
          <li>
            {t('Fries in a roll')}
            <span className={styles.span}> 15kr</span>
          </li>
        </ul>
      </fieldset>

      {/* <ReviewButton /> */}
    </div>
  )
}

export default FieldsetComponent
